import React from "react";
import { useField } from "react-final-form";
import { TextInput } from "@truevault/aquilo";
import { CONSENT_INPUT_TEXT_SIZE } from "../../../consentBanner/consentFieldStyles";
import {
  ConsentCaption,
  ConsentLinkButton,
  ConsentSettingRow,
} from "../../../consentBanner/ConsentSettingRow";
import { INFORMATIONAL_BANNER_TITLE_DEFAULT_TEXT } from "../../../../superorg/settings/ConsentBannerSettings";

const MAX_LENGTH = 64;

interface ConsentBannerTitleRowProps {
  formApi: { change: (field: string, value: string) => void };
}

/* We can only allow customizing this title text in the US since other regions have a language selector */
export const ConsentBannerUSTitleRow = ({ formApi }: ConsentBannerTitleRowProps) => {
  const { input } = useField<string>("informationalBannerTitle", { subscription: { value: true } });

  return (
    <ConsentSettingRow
      title="Banner title"
      helpText="Shown at the top of US opt-in and opt-out banners. Banners for other regions have a language selector, so their title can't be changed."
    >
      <div className="w-full max-w-[440px]">
        <TextInput
          field="informationalBannerTitle"
          inputTextSize={CONSENT_INPUT_TEXT_SIZE}
          aria-label="Banner title"
          maxLength={MAX_LENGTH}
          required
        />
      </div>
      <div className="flex flex-wrap items-center gap-x-[16px] gap-y-[4px]">
        <ConsentCaption>
          {(input.value ?? "").length}/{MAX_LENGTH}
        </ConsentCaption>
        <ConsentLinkButton
          onClick={() =>
            formApi.change("informationalBannerTitle", INFORMATIONAL_BANNER_TITLE_DEFAULT_TEXT)
          }
        >
          Reset to default
        </ConsentLinkButton>
      </div>
    </ConsentSettingRow>
  );
};
